import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from 'assets/not-found.png'


const _hoisted_1 = { class: "column text-center q-my-lg" }
const _hoisted_2 = {
  class: "text-weight-bold text-dark",
  style: {"font-size":"32px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "not-found-image"
  })
], -1)
const _hoisted_4 = { class: "text-h1 text-weight-bold text-dark" }
const _hoisted_5 = {
  key: 0,
  class: "text-h5 text-snabb5 q-my-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('reference.sorry')), 1),
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.text), 1),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.subtitle), 1))
      : _createCommentVNode("", true)
  ]))
}